// import {
//   Circle,
//   CloseBill, EditNewBtn,
//   EditSaveButtons,
//   Line,
//   SelectInput,
//   ValidationInput, VoidedButton,
// } from 'components';
// import {
//   Colors,
//   ErrorText,
//   FindErrorItem,
//   FindSuccessItem,
//   PermissionsList,
//   RolePermission,
//   useGlobalStyles,
//   useGlobalText,
// } from 'utils';
// import { FormControlLabel, FormLabel, Radio, RadioGroup } from '@material-ui/core';
// import React, { useEffect, useState } from 'react';
// import { useDispatch } from 'react-redux';
// import FormControl from '@material-ui/core/FormControl';
// import moment from 'moment';
// import {
//   customerPaymentActions,
//   httpRequestsOnErrorsActions,
//   httpRequestsOnSuccessActions,
// } from 'store';
// import { checkStatus,  } from '../../core';
// import { paymentMethods } from '../../core/constants';
// import { customerPaymentDetails } from './styles';
//
// const REQUEST_TYPE = 'EDIT_CUSTOMER_PAYMENT';
//
// export const CustomerInfoEdit = ({ info }) => {
//   const classes = customerPaymentDetails();
//   const globalStyles = useGlobalStyles();
//   const dispatch = useDispatch();
//   const [inputs, setInputs] = useState({});
//   const [error, setError] = useState({});
//   const [selectType, setSelectType] = useState('FACTORING');
//   const [disables, setDisabled] = useState(true);
//   const [open, setOpen] = useState(false);
//   const success = FindSuccessItem(REQUEST_TYPE);
//   const backError = FindErrorItem(REQUEST_TYPE);
//
//   useEffect(() => {
//     if (success) {
//       dispatch(httpRequestsOnSuccessActions.removeSuccess(REQUEST_TYPE));
//       setDisabled(true);
//     }
//   }, [success]);
//
//   useEffect(() => {
//     if (info) {
//       setSelectType(info ? info.factoringName ? 'FACTORING' : 'CUSTOMER' : 'FACTORING');
//       setInputs({
//         amount: info.amount,
//         pmtDate: moment(info.pmtDate).format('YYYY-MM-DD'),
//         pmtMethod: info.pmtMethod,
//         reference: info.reference,
//         factoring: info.factoringId ? info.factoringId : '',
//       });
//     }
//   }, [info]);
//
//   const handleChange = e => {
//     setInputs(prevState => ({ ...prevState, [e.target.name]: e.target.value }));
//     error === e.target.name && setError('');
//   };
//
//   const handleEdit = () => {
//     if (inputs.pmtDate && inputs.reference && inputs.pmtMethod && inputs.amount) {
//       const date = {
//         amount: +inputs.amount,
//         pmtDate: inputs.pmtDate,
//         pmtMethod: inputs.pmtMethod,
//         reference: inputs.reference,
//       };
//       dispatch(customerPaymentActions.editCustomerPayment(date, info.id, 'noLoad'));
//     } else {
//       setError(
//         !inputs.pmtDate ? 'pmtDate' :
//           !inputs.reference ? 'reference' :
//             !inputs.pmtMethod ? 'pmtMethod' :
//               !inputs.amount ? 'amount' :
//                 '',
//       );
//     }
//   };
//
//   const handleOpenCloseDelModal = () => {
//     setOpen(!open);
//   };
//
//   const handleChancel = () => {
//     dispatch(httpRequestsOnErrorsActions.removeError(REQUEST_TYPE));
//     setDisabled(true);
//     setError('');
//     setInputs({
//       amount: info.amount,
//       pmtDate: moment(info.pmtDate).format('YYYY-MM-DD'),
//       pmtMethod: info.pmtMethod,
//       reference: info.reference,
//       factoring: info.factoringId ? info.factoringId : '',
//     });
//   };
//
//
//
//   return (
//     <div className='full-width'>
//         <div className={globalStyles.spaceBetween}>
//           <div className={globalStyles.flexEnd}>
//             {RolePermission([PermissionsList.ALL_ACCESS?.code, PermissionsList.VOID_CUSTOMER_PAYMENT?.code]) &&
//               info && checkStatus(info) &&
//               <CloseBill
//                 handleCLick={() => handleOpenCloseDelModal('voidPayment')}
//                 text={'Void'} width={'77px'} right={'16px'}
//               />
//             }
//             {info && !checkStatus(info) ?
//               <VoidedButton />
//               :
//               RolePermission([PermissionsList.ALL_ACCESS?.code, PermissionsList.CREATE_CUSTOMER_PAYMENT?.code]) &&
//               <div style={{marginTop: '-55px', marginRight: '16px'}}>
//                 <EditNewBtn/>
//               {/*<EditSaveButtons*/}
//               {/*  type={REQUEST_TYPE}*/}
//               {/*  handleChancel={handleChancel}*/}
//               {/*  handleSetEdit={() => setDisabled(false)}*/}
//               {/*  handleSaveInfo={handleEdit}*/}
//               {/*/>*/}
//               </div>
//             }
//           </div>
//         </div>
//
//         <div className={globalStyles.flexAndFullWidth}>
//           <div className={globalStyles.fullWidth}>
//             <div className={classes.spaceBetween}>
//               <ValidationInput
//                 className={info && globalStyles.inputTextFieldBlue}
//                 disabled={disables}
//                 style={globalStyles.simpleInput}
//                 variant={'outlined'}
//                 onChange={handleChange}
//                 value={inputs.pmtDate}
//                 type={'date'}
//                 label={'Date*'}
//                 name="pmtDate"
//                 typeError={error === 'pmtDate' && ErrorText.field}
//               />
//               <ValidationInput
//                 className={info && globalStyles.inputTextFieldBlue}
//                 disabled={disables}
//                 style={globalStyles.simpleInput}
//                 variant={'outlined'}
//                 name={'reference'}
//                 label={'Reference Number*'}
//                 type={'text'}
//                 typeError={error === 'reference' ? ErrorText.field : ''}
//                 onChange={handleChange}
//                 value={inputs.reference}
//               />
//               <SelectInput
//                 className={info && globalStyles.inputTextFieldBlue}
//                 disabled={disables}
//                 style={globalStyles.simpleInput}
//                 name={'pmtMethod'}
//                 label={'Payment Method*'}
//                 handleSelect={handleChange}
//                 value={inputs.pmtMethod}
//                 list={paymentMethods}
//                 typeError={error === 'pmtMethod' ? ErrorText.field : ''}
//                 type={'id'}
//               />
//               <ValidationInput
//                 className={info && globalStyles.inputTextFieldBlue}
//                 disabled={disables}
//                 variant={'outlined'}
//                 name={'amount'}
//                 label={'Amount*'}
//                 type={'number'}
//                 typeError={error === 'amount' ? ErrorText.field :
//                   backError?.error === 'The used amount from this pmt is higher than the total pmt amount you are trying to set' ? 'The used amount from this pmt is higher than the total pmt amount you are trying to set' :
//                     ''}
//                 onChange={handleChange}
//                 value={inputs.amount}
//               />
//             </div>
//             <FormControl disabled={true} className={classes.checkbox}>
//               <FormLabel className={classes.title} id='demo-row-radio-buttons-group-label'>This payment is
//                 from:</FormLabel>
//               <RadioGroup
//                 onChange={(e) => setSelectType(e.target.value)}
//                 row
//                 aria-labelledby='demo-row-radio-buttons-group-label'
//                 name='selectType'
//                 value={selectType}
//               >
//                 <FormControlLabel
//                   defaultChecked={selectType === 'FACTORING'}
//                   value='FACTORING'
//                   control={<Radio />}
//                   label='Factoring Comapny'
//                 />
//                 <FormControlLabel
//                   defaultChecked={selectType === 'CUSTOMER'}
//                   value='CUSTOMER'
//                   control={<Radio />}
//                   label='Customer'
//                 />
//               </RadioGroup>
//             </FormControl>
//           </div>
//         </div>
//
//       {/*<SimpleModal*/}
//       {/*  handleOpenClose={() => setAddLoad(!addLoad)}*/}
//       {/*  openDefault={addLoad}*/}
//       {/*  content={*/}
//       {/*    <AddLoad*/}
//       {/*      customerPaymentLoad={customerPaymentLoad}*/}
//       {/*      loadDate={info}*/}
//       {/*      closeModal={() => setAddLoad(!addLoad)}*/}
//       {/*      handleOpenClose={() => setAddLoad(!addLoad)}*/}
//       {/*    />*/}
//       {/*  }*/}
//       {/*/>*/}
//
//       {/*<SimpleModal*/}
//       {/*  handleOpenClose={handleOpenCloseDelModal}*/}
//       {/*  openDefault={open}*/}
//       {/*  content={*/}
//       {/*    <DeleteElement*/}
//       {/*      loading={loadVoid}*/}
//       {/*      type={'void'}*/}
//       {/*      text={'Are you sure you want to void this payment?'}*/}
//       {/*      handleClose={handleOpenCloseDelModal}*/}
//       {/*      handleDel={handleVoidPayment}*/}
//       {/*      info={'Bill'}*/}
//       {/*      modalText={'This action will undo everything that payment application caused.'}*/}
//       {/*    />*/}
//       {/*  }*/}
//       {/*/>*/}
//     </div>
//   );
// };


import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import {
  DateRow, EditNewBtn, MinLoader,
  PriceRow, TextRow, TypeRow,
  ValidationInput, SelectType,
} from 'components';
import { AntSwitch, ErrorText, FindLoad, FindSuccess, useGlobalStyles } from 'utils';
import { customerActions, customerPaymentActions, httpRequestsOnSuccessActions } from 'store';
import { paymentMethods, sourceEnum, sourceList } from './constants';

const ACTION_TYPE = 'EDIT_CUSTOMER_PAYMENT';
export const CustomerInfoEdit = ({  }) => {
  const { customerPaymentById, customersList, customerPaymentLoad } = useSelector((state) => ({
    customerPaymentById: state.customerPayments.customerPaymentById,
    customersList: state.customers.customersList,
    customerPaymentLoad: state.customerPayments.customerPaymentLoad,
  }));
  const globalStyles = useGlobalStyles();
  const dispatch = useDispatch();
  const loader = FindLoad(ACTION_TYPE);
  const success = FindSuccess(ACTION_TYPE);
  const [inputs, setInputs] = useState({});
  const [error, setError] = useState({});
  const [miscellaneous, setMiscellaneous] = useState(false);
  const [edit, setEdit] = useState(false);
  const applied = customerPaymentLoad?.flat()?.find((i) => i?.status === "APPLIED");

  useEffect(() => {
    if (customerPaymentById?.id) {
      setMiscellaneous(customerPaymentById?.miscellaneous)
      setInputs({
        pmtDate: moment(customerPaymentById?.pmtDate).format('YYYY-MM-DD'),
        source: customerPaymentById?.source,
        customer: customerPaymentById?.customerId,
        reference: customerPaymentById?.reference,
        pmtMethod: customerPaymentById?.pmtMethod,
        amount: customerPaymentById?.amount,
        sourceDescription: customerPaymentById?.sourceDescription || '',
      });
    }
  }, [customerPaymentById]);

  useEffect(() => {
    dispatch(customerActions.getCustomers({ status: 'ACTIVE' }));
  }, []);

  useEffect(() => {
    if (success.length) {
      dispatch(httpRequestsOnSuccessActions.removeSuccess(ACTION_TYPE));
      setEdit(false);
    }
  }, [success]);
  const handleEdit = () => {
    if (inputs.pmtDate && inputs?.source && inputs.reference && inputs.pmtMethod && inputs.amount) {
      const date = {
        source: inputs.source,
        amount: +inputs.amount,
        pmtMethod: inputs.pmtMethod,
        customer: inputs.customer ? inputs.customer : null,
        reference: inputs.reference,
        pmtDate: moment(inputs.pmtDate).format('YYYY-MM-DD'),
      };
      if(inputs?.source === sourceEnum.OTHER){
        inputs?.sourceDescription ? date.sourceDescription = inputs.sourceDescription : delete date.sourceDescription;
      }else{
        date.sourceDescription = null
      }
      dispatch(customerPaymentActions.editCustomerPayment(date, customerPaymentById?.id, 'noLoad'));
    } else {
      setError(
        !inputs.pmtDate ? 'pmtDate' :
          !inputs.source ? 'source' :
            !inputs.reference ? 'reference' :
              !inputs.pmtMethod ? 'pmtMethod' :
                !inputs.amount ? 'amount' :
                  '',
      );
    }
  };
  const handleChange = e => {
    setInputs(prevState => ({ ...prevState, [e.target.name]: e.target.value }));
    error === e.target.name && setError('');
  };
  const handleCancel = () => {
    setInputs({
      pmtDate: moment(customerPaymentById?.pmtDate).format('YYYY-MM-DD'),
      source: customerPaymentById?.source,
      customer: customerPaymentById?.customerId,
      reference: customerPaymentById?.reference,
      pmtMethod: customerPaymentById?.pmtMethod,
      amount: customerPaymentById?.amount,
    });
    setEdit(false);
  };
  const handleMis = () => {
    setMiscellaneous(!miscellaneous);
    dispatch(customerPaymentActions.changeCustomerPmtMisc(customerPaymentById?.id, {miscellaneous: !miscellaneous}))
  }

  return (
    <>
      {!edit ?
        <div className="full-width">
          <div style={{ marginTop: '-56px', marginLeft: '-16px', }} className="flex-end">
            <EditNewBtn handleClick={() => setEdit(true)} />
          </div>
          <div style={{ marginTop: 30, padding: '0 16px 24px' }}>
            <div className="flex-align-center" style={{ gap: 12, marginBottom: 10 }}>
              <div className="customer-info-row-wrapper">
                <p className="customer-info-row-title">Date:</p>
                <div className="customer-info-row-value">
                  <DateRow date={customerPaymentById?.pmtDate} />
                </div>
              </div>
              <div className="customer-info-row-wrapper">
                <p className="customer-info-row-title">Customer:</p>
                <div className="customer-info-row-value">
                  <TextRow name={customerPaymentById?.customerName ? customerPaymentById?.customerName : 'N/A'} />
                </div>
              </div>
              <div className="customer-info-row-wrapper">
                <p className="customer-info-row-title">Source:</p>
                <div className="customer-info-row-value">
                  <TextRow name={customerPaymentById?.source} textWidth={7} />
                </div>
              </div>
              <div className="customer-info-row-wrapper">
                <p className="customer-info-row-title">Method:</p>
                <div className="customer-info-row-value">
                  <TypeRow text={customerPaymentById?.pmtMethod} />
                </div>
              </div>
              <div className="customer-info-row-wrapper">
                <p className="customer-info-row-title">Amount:</p>
                <div className="customer-info-row-value">
                  <PriceRow info={customerPaymentById?.amount} />
                </div>
              </div>
              <div className="customer-info-row-wrapper" style={{ minWidth: '200px', width: '200px' }}>
                <p className="customer-info-row-title">Ref:</p>
                <div className="customer-info-row-value">
                  <TextRow name={customerPaymentById?.reference} />
                </div>
              </div>
            </div>
            {customerPaymentById?.sourceDescription && customerPaymentById?.source === sourceEnum.OTHER &&
            <div className="customer-info-row-wrapper" style={{ minWidth: '100%', width: '100%', marginBottom: 10 }}>
              <p className="customer-info-row-title">Description:</p>
              <div className="customer-info-row-value" style={{width: '100%'}}>
                <TextRow name={customerPaymentById?.sourceDescription} />
              </div>
            </div>
            }
            <div className="miscellaneous-wrapper">
              <p className="miscellaneous-wrapper-title">Set Payment as Miscellaneous</p>
              <AntSwitch
                disabled={!!applied}
                onClick={handleMis}
                checked={miscellaneous}
              />
            </div>
          </div>
        </div>
        :
        <div className="full-width" style={{ padding: '24px 16px' }}>
          <div className="flex-align-start" style={{ gap: 12 }}>
            <div style={{ width: '150px' }}>
              <ValidationInput
                variant={'outlined'}
                onChange={handleChange}
                value={inputs.pmtDate}
                type={'date'}
                label={'Date*'}
                name="pmtDate"
                typeError={error === 'pmtDate' && ErrorText.field}
                className={inputs?.pmtDate && globalStyles.inputTextFieldBlue}
              />
            </div>
            <div style={{ width: '100%', opacity: !!applied ? 0.5 : 1 }}>
              <SelectType
                disabled={!!applied}
                loadType={'GET_CUSTOMERS'}
                title={'Customers'}
                name={'customer'}
                handleSelect={handleChange}
                defaultValue={inputs.customer}
                list={customersList?.customers || []}
                error={error}
                typeError={error === 'customer' ? `Customer is required` : ''}
                renderValue={(i) => i?.name}
              />
            </div>
            <div style={{ width: '100%' }}>
              <SelectType
                title={'Source*'}
                name={'source'}
                handleSelect={handleChange}
                defaultValue={inputs.source}
                list={sourceList}
                error={error}
                typeError={error === 'source' ? `Customer is required` : ''}
                renderValue={(i) => i?.name}
              />
            </div>
            <div style={{ width: '100%' }}>
              <ValidationInput
                variant={'outlined'}
                name={'reference'}
                label={'Reference Number*'}
                type={'text'}
                typeError={error === 'reference' ? ErrorText.field : ''}
                onChange={handleChange}
                value={inputs.reference}
                className={inputs?.reference && globalStyles.inputTextFieldBlue}
              />
            </div>
            <div style={{ width: 180, minWidth: 180 }}>
              <SelectType
                title={'Payment Method*'}
                name={'pmtMethod'}
                handleSelect={handleChange}
                defaultValue={inputs.pmtMethod}
                list={paymentMethods}
                error={error}
                typeError={error === 'pmtMethod' ? `Customer is required` : ''}
                renderValue={(i) => i?.name}
              />
            </div>
            <div style={{ width: 150, minWidth: 150 }}>
              <ValidationInput
                variant={'outlined'}
                name={'amount'}
                label={'Amount*'}
                type={'number'}
                typeError={error === 'amount' ? ErrorText.field : ''}
                onChange={handleChange}
                value={inputs.amount}
                className={inputs?.amount && globalStyles.inputTextFieldBlue}
              />
            </div>
          </div>

          {inputs.source === sourceEnum.OTHER &&
          <div style={{ width: '490px' }}>
              <ValidationInput
                variant={'outlined'}
                name={'sourceDescription'}
                label={'Description'}
                type={'text'}
                typeError={error === 'sourceDescription' ? ErrorText.field : ''}
                onChange={handleChange}
                value={inputs.sourceDescription}
                className={inputs?.sourceDescription && globalStyles.inputTextFieldBlue}
              />
          </div>
          }

          <div className="miscellaneous-wrapper">
            <p className="miscellaneous-wrapper-title">Set Payment as Miscellaneous</p>
            <AntSwitch
              disabled={!!applied}
              onClick={handleMis}
              checked={miscellaneous}
            />
          </div>
          <div className="flex-end" style={{ marginTop: 10 }}>
            <div className="flex-align-center" style={{ gap: 12 }}>
              <button className="customer-pmt-cancel" onClick={handleCancel}>Cancel</button>
              <button className="customer-pmt-save" onClick={handleEdit}>
                {loader?.length ?
                  <MinLoader style={{ margin: 0, position: 'relative' }} color={'#172B4D'} />
                  :
                  'Save'
                }</button>
            </div>
          </div>

        </div>
      }
    </>
  );
};